import { get, includes } from 'lodash';
import { takeLatest } from 'redux-saga/effects';

import { ON_SOCKET_ACTIVITY } from 'containers/App/constants';

// eslint-disable-next-line require-yield
function* sagaOnSocketActivity(action: any): any {
  const namespace = get(action, 'data.namespace');

  if (includes(['api:appointments:confirm', 'api:appointments:cancel'], namespace)) {
    // TODO update stores with appointment updates
  }
}

export default function* sagaWatchersAppointment() {
  yield takeLatest(ON_SOCKET_ACTIVITY, sagaOnSocketActivity);
}
